var React = require('react');

function IconEyeOn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M13 6.133A10.683 10.683 0 0 1 22.622 12 10.683 10.683 0 0 1 13 17.867 10.683 10.683 0 0 1 3.378 12 10.683 10.683 0 0 1 13 6.133M13 4a12.9 12.9 0 0 0-12 8 12.9 12.9 0 0 0 12 8 12.9 12.9 0 0 0 12-8 12.9 12.9 0 0 0-12-8zm0 5.333A2.667 2.667 0 1 1 10.273 12 2.7 2.7 0 0 1 13 9.333M13 7.2A4.863 4.863 0 0 0 8.091 12a4.91 4.91 0 0 0 9.818 0A4.863 4.863 0 0 0 13 7.2z","transform":"translate(-1 -4)"}));
}

IconEyeOn.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = IconEyeOn;

IconEyeOn.default = IconEyeOn;
